import { createContext, useContext } from 'react';

export const FormContext = createContext(null);

export function FormProvider({ value, children }) {
  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
}

export function useFormContext() {
  return useContext(FormContext);
}
